<template>
  <b-modal id="modal-search" title="Search Catalog" :ok-title="okTitle" :ok-only="success" @ok="performSearch"
           @show="resetModal">

    <div>
      <div v-if="!success">
        <b-form @submit.prevent="performSearch">
          <b-form-group
            id="usedSchema-group"
            label="Used Schema"
            label-for="usedSchema"
          >
            <b-form-input
              id="usedSchema"
              v-model="searchValue"
              type="text"
              placeholder="Used Schema"
            ></b-form-input>
          </b-form-group>
        </b-form>
        <div>
          <b-alert :show="error" variant="danger">{{ errorMessage }}</b-alert>
        </div>
      </div>
      <div v-if="success">
        <b-alert :show="success" variant="success">{{ message }}</b-alert>

      </div>
    </div>
  </b-modal>
</template>

<script>
import http from '../http'

export default {
  name: 'search-catalog',

  data () {
    return {
      message: '',
      errorMessage: '',
      usedSchema: '',
      usedSchemaTitle: '',
      identifier: '',
      operator: '',
      searchValue: '',
      error: false,
      success: false
    }
  },
  computed: {
    okTitle: function () {
      return this.success ? 'OK' : 'Perform Search'
    }
  },
  methods: {
    performSearch (evt) {
      this.error = false
      if (!this.success) {
        evt.preventDefault()

        http.post('/api/catalogSearch', {
          usedSchema: this.usedSchema,
          usedSchemaTitle: this.usedSchemaTitle,
          identifier: this.identifier,
          operator: this.operator,
          searchValue: this.searchValue
        }).then((response) => {
          console.log('received msg ' + response.data.message)
          this.message = response.data.message
          this.success = true
        }).catch((err) => {
          console.log('error catched')
          if (err.response) {
            // Request made and server responded
            console.log(err.response.data)
            console.log(err.response.status)
            console.log(err.response.headers)
            this.error = true
            this.errorMessage = err.response.data.message
          } else if (err.request) {
            this.error = true
            this.errorMessage = 'Could not perform request'
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message)
            this.error = true
            this.errorMessage = 'Could not perform request'
          }
        })
      }
    },

    resetModal () {
      this.message = ''
      this.error = false
      this.success = false
      this.usedSchema = ''
      this.usedSchemaTitle = ''
      this.identifier = ''
      this.operator = ''
      this.searchValue = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Search.vue